import { useTranslation } from "react-i18next"
import { observer } from 'mobx-react-lite'
import { useStore } from '../../contexts/store'
import { PodClass } from '../../classes/Pod'
import ErrorBoundaryComponent from '../ErrorBoundaryComponent'

import Activity from '../Pod/Activity/Activity'
import Conversations from '../Pod/Conversation/Conversations'
import PageWrapper from './PageWrapper'
import PodDashboard from '../Pod/PodDashboard/PodDashboard'
import PodMaterial from '../Pod/PodMaterial/PodMaterial'
import PodNotes from '../Pod/PodNotes'
import PodReadingQuestions from '../Pod/PodReadingQuestions'
import PodTags from '../Pod/PodTags/PodTags'
import PodUsers from '../Pod/PodUsers'
import Settings from '../Pod/Settings'


const Pod = ({podId, activeTabIndex, activeConversationId, activeSubTabIndex}: {podId: string, activeTabIndex?: string, activeConversationId?: string, activeSubTabIndex?: string}) => {
  const { t } = useTranslation()
  const { podStore } = useStore()
  const pod:PodClass|null = podStore.pod
  if (pod === null) return <div>'pod' is null when trying to show pod</div>

  const Switch = () => {
    if(activeTabIndex === "activity") return (
      <PageWrapper title={t("Activity")}>
        <Activity />
      </PageWrapper>
    )
    if(activeTabIndex === "contents") return (
      <PageWrapper sxCard={{padding: "0"}}>
        <PodMaterial pod={pod} />
      </PageWrapper>
    )
    if(activeTabIndex === "conversations") return (
      <PageWrapper sxCard={{overflowY: "auto", padding: "0"}}>
        <Conversations activeConversationId={activeConversationId} />
      </PageWrapper>
    )
    if(activeTabIndex === "notes") return (
      <PageWrapper title={t('{{numberOfNotes}} notes in this Pod', {numberOfNotes: pod.getNumberOfNotes(pod.getPdfFiles())})} sxCard={{padding: 3}} icon={'podNotes'}>
        <PodNotes pod={pod} />
      </PageWrapper>
    )
    if(activeTabIndex === "people") return (
      <PageWrapper title={t("People")} sxCard={{padding: 3}} icon={'podPeople'}>
        <PodUsers />
      </PageWrapper>
    )
    if(activeTabIndex === "questions") return (
      <PageWrapper>
        <PodReadingQuestions pod={pod} />
      </PageWrapper>
    )
    if(activeTabIndex === "settings") return (
      <PageWrapper sxCard={{padding: 3}} title={t("Settings")} icon={'podSettings'} helptext={t("pod_settings_helper")} >
        <Settings activeSubTabIndex={activeSubTabIndex} />
      </PageWrapper>
    )
    if(activeTabIndex === "tags") return (
      <PageWrapper sxCard={{paddingLeft: 0, paddingRight: 0}}>
        <PodTags pod={pod} />
      </PageWrapper>
    )
    return (
      <PodDashboard pod={pod} />
    )
  }

  // this component should not have any functionality,
  // but only serves to switch between the tabs
  return (
    <ErrorBoundaryComponent>
      <Switch />
    </ErrorBoundaryComponent>
  )

}

export default observer(Pod)
